import Slider from 'react-slick'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import testimonial1 from '../../images/testimonial/img-1.jpeg'
// import testimonial2 from '../../images/testimonial/img-2.jpg'
// import testimonial3 from '../../images/testimonial/img-3.jpg'
import Quote from '../../images/testimonial/quote.svg'

const testimonials = [
  {
    id: '01',
    Des: 'Industrial oil gas services manufacture found in 1996 still working',
    Title: '',
    Sub: '',
    image: testimonial1,
  },
 
]

const Testimonial = (props) => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          dots: true,
          arrows: false,
        },
      },
    ],
  }

  return (
    <section className={'' + props.hclass}>
      <Slider {...settings} className="testimonial-slider">
        {testimonials.slice(0, 3).map((testimonial, item) => (
          <div className="item" key={item}>
            <div className="bg-image">
              <img src={testimonial.image} alt="testimonial" />
            </div>
            <div className="content fade_bottom">
              <div className="icon">
                <img src={Quote} alt="quote" />
              </div>
              <h3>{testimonial.Des}</h3>
              <span>{testimonial.Sub}</span>
              <h4>{testimonial.Title}</h4>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  )
}

export default Testimonial
